import dayjs from "dayjs"

export const JSON_MAPPINGS: Record<string, any> = {
    "681dd41e26456116c7f304ee": {
        "overall_summary.global_summary": "## Overview\n{value}",
        "overall_summary.funds_use": "### Grant Fund Use\n{value}",
        "overall_summary.collective_outcomes_achieved": "### Collective Outcomes\n{value}",
        "overall_summary.progress_summary": "### Project Progress\n{value}",
        "overall_summary.goals_and_objectives_completion": "### Goals & Objectives Completion\n{value}",

        "section_summaries[].grantee_name": "### {value}",
        "section_summaries[].project_title": "#### Project: {value}",
        "section_summaries[].impact_and_activities_summary": "**Impact and Activities Summary:**\n{value}",
        "section_summaries[].key_outcomes": "**Key Outcomes:**\n{list}",
        "section_summaries[].grant_meaningfull_metrics": "**Meaningful Metrics:**\n{list}"
    },
    "67f520edcb6927c7b29ab021": {
        "changes[].change_type": "## {value} Changes",
        "changes[].change_details.original_text": "### Original Text\n```\n{value}\n```",
        "changes[].change_details.new_text": "### New Text\n```\n{value}\n```",
        "changes[].change_details.context": "### Context\n{value}",
        "changes[].change_details.semantic_change.semantic_details": "### Semantic Impact\n{value}",
        "changes[].location": "### Location\n{value}",
        "changes[].page": "### Page\n{value}",
        "changes[].section": "### Section\n{value}",
        "changes[].change_author": "### Modified By\n{value}",
        "changes[].change_date_timestamp": {
            template: "### Modification Date\n{value}",
            transform: (value: string | number | Date) => dayjs(value).format("MMMM D, YYYY [at] h:mm A")
        },
        "changes[].document_id": "### Document ID\n{value}"
    }
}